import React from 'react'
import { Stack, Typography } from '@mui/material'
import type { OrgInvitation } from 'pure-js/types/OrgInvitation'

import { Button } from '../../../../interaxDesignSystemComponents'
import { DefaultModal } from '../../../../shared/components/DefaultModal'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'

interface RevokeInviteConfirmModalProps {
  invite: OrgInvitation | null
  onClose: () => void
  onConfirm: () => void
  isPending: boolean
}

export const RevokeInviteConfirmModal: React.FC<RevokeInviteConfirmModalProps> = ({
  invite,
  onClose,
  onConfirm,
  isPending
}) => {
  const { t } = useTranslation()

  return (
    <DefaultModal isOpen={invite !== null} onClose={onClose} maxWidth="420px">
      <Stack spacing={2.5}>
        <Typography sx={{ fontSize: '20px', fontWeight: 600, color: INTERAX_COLORS.white }}>
          {t('org.invites.revokeTitle')}
        </Typography>
        {invite && (
          <Typography sx={{ fontSize: '14px', color: INTERAX_COLORS.white70, lineHeight: 1.5 }}>
            {t('org.invites.revokeBody', { email: invite.email })}
          </Typography>
        )}
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <Button variant="secondary" size="small" onClick={onClose}>
            {t('org.members.invite.cancel')}
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onConfirm}
            disabled={isPending}
            style={{
              backgroundColor: INTERAX_COLORS.redError,
              borderColor: INTERAX_COLORS.redError
            }}
          >
            {t('org.invites.revokeConfirm')}
          </Button>
        </Stack>
      </Stack>
    </DefaultModal>
  )
}
